import { useSyncExternalStore } from "react";

import {
  getPermissionsState,
  hasPermission,
  subscribePermissions,
} from "@/lib/stores/permissions-store";

// Reactive read of the RBAC permissions store. `getPermissionsState` returns a stable
// frozen object until something actually changes (same caching contract as
// use-user-preferences), so it slots straight into useSyncExternalStore.
export function usePermissions() {
  return useSyncExternalStore(subscribePermissions, getPermissionsState, getPermissionsState);
}

// Reactive boolean gate: does the current user meet `level` on `module`?
// Subscribing keeps the answer live across login, refresh and permission edits.
export function useHasPermission(module, level = "view") {
  usePermissions();
  return hasPermission(module, level);
}

export function useIsAdmin() {
  return usePermissions().isAdmin;
}
